import DB from '../data/mockData';

function levelBorder(l) {
  if (l === 'hi') return { borderColor: 'rgba(214,59,10,.3)', background: 'var(--red2)' };
  if (l === 'me') return { borderColor: 'rgba(184,92,0,.3)', background: 'var(--amber2)' };
  return { borderColor: 'var(--teal4)', background: 'var(--teal3)' };
}

function tagPill(l) {
  if (l === 'hi') return 'p-r';
  if (l === 'me') return 'p-a';
  return 'p-t';
}

export default function MarketSignals() {
  return (
    <div className="content">
      {/* Banner */}
      <div className="d-flex align-items-center gap-3 p-3 rounded-4 flex-wrap" style={{ background: 'linear-gradient(135deg,#0c2f45,#1a5e7d)' }}>
        <div className="fo-banner-ico">🔔</div>
        <div className="flex-grow-1 text-white" style={{ fontSize: '12.5px', lineHeight: 1.5, opacity: .92 }}>
          <strong style={{ color: '#7DD6F0' }}>Nova monitors Farminform, CBG, NHG, Z-Index and supplier lists in real time.</strong> Signals are ranked by commercial relevance for the Dutch generic market.
        </div>
        <span className="ai-badge" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>✦ Real-time</span>
      </div>

      {/* Signal cards */}
      <div className="row g-3">
        {DB.signals.map((s, i) => {
          const style = levelBorder(s.level);
          return (
            <div className="col-md-6 col-xl-4" key={i}>
              <div className="d-flex gap-2 p-3 rounded-3" style={{ border: '1.5px solid', cursor: 'pointer', transition: 'all .18s', ...style }}>
                <div style={{ fontSize: 20, flexShrink: 0, marginTop: 1 }}>{s.ico}</div>
                <div>
                  <div style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--navy)', marginBottom: 3 }}>{s.title}</div>
                  <div style={{ fontSize: '11.5px', color: 'var(--t2)', lineHeight: 1.4 }}>{s.desc}</div>
                  <div className="d-flex flex-wrap gap-1 mt-2">
                    {s.tags.map((t, j) => <span key={j} className={`pill ${tagPill(s.level)}`}>{t}</span>)}
                    {s.updated && <span className="ai-badge">{s.updated}</span>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
